<template>
	<div>
		<vue-progress-bar></vue-progress-bar>
		<b-navbar toggleable="lg" type="light" variant="light">
			<b-navbar-brand v-b-toggle.sidebar-1 @click="goTo('Dashboard')" style="cursor: pointer;">
				<div class="i">
					{{ $lang.appName }}
				</div>
			</b-navbar-brand>

			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>
				<!-- <b-navbar-nav>
					<b-nav-item @click="goTo('Workers')" :active="currentRoute == $lang.modules.workers">{{ $lang.modules.Workers }}</b-nav-item>
					<b-nav-item @click="goTo('Attendance')" :active="currentRoute == $lang.modules.attendance">{{ $lang.modules.Attendance }}</b-nav-item>
				</b-navbar-nav> -->

				<b-navbar-nav class="ml-auto">
					<b-nav-item-dropdown :text="$lang.lang" right>
						<b-dropdown-item @click="changeLang('en')" :active="activeLang == 'en'">EN</b-dropdown-item>
						<b-dropdown-item @click="changeLang('es')" :active="activeLang == 'es'">ES</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-nav-item-dropdown right>
						<template v-slot:button-content>
							<em>{{users.currentUser.email}}</em>
						</template>
						<ul class="dropdown-menu">
							<li><a href="#">Service C1</a></li>
							<li><a href="#">Service C2</a></li>
							<li><a href="#">Service C3</a></li>
							<li><a href="#">Service C4</a></li>
							<li><a href="#">Service C5</a></li>
						</ul>
						<b-dropdown-item href="#">{{ $lang.common.profile }}</b-dropdown-item>
						<b-dropdown-item @click="logout">{{ $lang.common.logout }}</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
	</div>
</template>

<script>
import { mapState } from 'vuex'

const fb = require('../firebaseConfig.js')

export default {
	data() {
		return {
			activeLang: 'es',
		}
	},
	computed: {
		...mapState(['users', 'currentRoute']),
	},
	methods: {
		logout() {
			fb.auth.signOut().then(() => {
				this.$store.dispatch('clearData')
				this.$router.push('/login')
			}).catch(err => {
				console.log(err)
			})
		},
		changeLang(langCode) {
			this.activeLang = langCode
			this.$setLang(langCode)
		},
		goTo(routeName) {
			this.$store.commit('setCurrentRoute', routeName)
			this.$router.push({name: routeName}).catch(err => {
				console.log(err)
			})
		}
	},
	created() {
		this.$store.commit('setCurrentRoute', this.$lang.modules[this.$route.name.toLowerCase()])
	}
}
</script>


